import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import * as Sentry from "@sentry/react";
import { useToast } from "@speakai/ui/toast";
import { listRecoverableTakes } from "../take-store";

const RECORD_PAGE_PATH = "/upload/record";

let noticeCheckedForUserId: string | null = null;

/** Once per user per page load, toasts when `userId` has an unsaved recording in this browser, except on the record page, which shows its own banner. */
export function useUnsavedTakeNotice(userId: string | undefined): void {
  const toast = useToast();
  const { t } = useTranslation();

  useEffect(() => {
    if (!userId || noticeCheckedForUserId === userId) return;
    noticeCheckedForUserId = userId;
    if (window.location.pathname.startsWith(RECORD_PAGE_PATH)) return;
    listRecoverableTakes(userId)
      .then((takes) => {
        if (takes.length === 0 || window.location.pathname.startsWith(RECORD_PAGE_PATH)) return;
        toast.info(
          t("UPLOAD.RECORD.RECOVER_TOAST_TITLE", "You have an unsaved recording"),
          t("UPLOAD.RECORD.RECOVER_TOAST_DESC", "Open the record page to upload, download or discard it."),
        );
      })
      .catch((err) => Sentry.captureException(err, { tags: { feature: "recorder" } }));
  }, [userId, toast, t]);
}
